
// body load
$(window).load(function() {
	$('body').animate({ opacity:1 },500);	
  
  	$('html, body').animate({
        scrollTop: $('body').offset().top + '1px'
    }, 'slow');
  	    
    $(".home-banner .hero").addClass('is-inview');  
	$(".home-banner .width-350").addClass('is-inview'); 
  
  
  	$(".link_to_reviews a").click(function() {
    $('html, body').animate({
        scrollTop: $("#shopify-product-reviews").offset().top
    }, 2000);	
    });
  
    $(".about_video").click();
    $(".about_video").prop('muted', false);
  
});




$(window).on('load resize', function () {
  
var ourheight = $(".btn_image" ).height();
$(".experienceInfo").css({'height': ourheight});

var oursheight = $(".container.ContentExperience:nth-child(4) .btn_image" ).height();
$(".container.ContentExperience:nth-child(4) .experienceInfo").css({'height': oursheight});

var ourroots = $(".roots_right" ).height();
$(".our_roots").css({'height': ourroots});  
  
  
var wwidth = $(window).width();	
if(	wwidth > 767) {	
  $(".page_title_list").insertBefore(".static_page_nav.list-menu");        
} 
else {	
  $(".static_page_nav.list-menu").insertBefore(".page_title_list");
  
  $(".roots_right").insertBefore(".roots_left");
   
  $(".video").click();
  
  
  
  $(".list-menu ul li a").click(function(){
    $(".list-menu ul").slideUp('slow');    
});
  
}  
  
});


$(document).ready(function(){  
    
  $(".link-contact").attr('href', 'https://honor-md.myshopify.com/pages/contact');
  
  $(".about_video").click(function() {
    	//$(this).pause();
    	//$(this).prop('muted', !$(this).prop('muted'));
    	//this.paused ? this.play() : this.pause();
    	//$(this).prop('muted', !$(this).prop('muted'));
  });
  
  $(".about_video").prop('muted', true);
  
  $(document).on('click', '.about_video', function (e) {

    var video = $(this).get(0);
    if (video.paused === false) {
        video.pause();
      	$('.about_top .page-width').addClass('paused');
    } else {
        video.play();
      	//alert('1');
        $('.about_top .page-width').removeClass('paused');
    }
    
    if($('.about_top .page-width').hasClass('paused')){
        $(".about_video").prop('muted', false);
    }

    return false;
 });
  
  
  $(".about_top .page-width span").click(function() {
    	//alert('1');
    	$(".about_video").click();
  });
  
  
  $("#shopify-section-hero").click(function(){
    window.open($(this).find("a.hero__btn").attr("href"), '_self');
  });
  
   setTimeout(function() {        
     
    if ($(".spr-summary").find(".spr-starrating").length > 0){ 
      	$(".spr-starrating.spr-summary-starrating").clone().appendTo(".move_reviews_here");
      	$(".quick_reviews div label, .link_to_reviews a").show();
    } else {
      	//alert('1');
      	$(".quick_reviews").html('No reviews');
    }
    
  }, 1500);
  
  $( ".mobile_title .SubPage, .mobile_title .SubPage-title" ).click(function() {  
  //$(".static_page_nav ul").slideToggle();    
});
  
  
  $(".list-menu h3").click(function(){
      $(".list-menu ul").slideToggle('slow');
      $(this).toggleClass('active_h3');
  });

  $(".disabled_btn").click(function(){
    	$(".bis-button.BIS_trigger").click();	
  });
  
  
  $(".list-menu ul li a").click(function(){
  $(".list-menu h3").removeClass('active_h3');
});
  
  //responsive menu open/close
  $(".left_menu a").click(function() {
    //alert('1');
    	$('.tablet-menu').addClass('active');
		$('.tablet-menu-overlay').show();
    	$("#added-box-wrapper").removeClass('open-bag');
  });
  
  $(".tablet-menu-overlay").click(function() {
    	$('.tablet-menu').removeClass('active');
		$('.tablet-menu-overlay').hide();
  });
  
  
  $(".list-menu .contact").click(function() {
      	$(".list-menu a").removeClass("active");
      	$(this).addClass("active");
    	$(".SubPage").fadeOut();
    	$(".SubPage-title").fadeOut();
    	$("div.contact").delay(500).fadeIn();
    });
  
  
  	$(".list-menu .faq").click(function() {
      	$(".list-menu a").removeClass("active");
      	$(this).addClass("active");
    	$(".SubPage").fadeOut();
      	$(".SubPage-title").fadeOut();
    	$("div.help-faq").delay(500).fadeIn();
    });
    
    $(".list-menu .returns").click(function() {
      	$(".list-menu a").removeClass("active");
      	$(this).addClass("active");
    	$(".SubPage").fadeOut();
      	$(".SubPage-title").fadeOut();
    	$("div.returns").delay(500).fadeIn();
    });
    
     $(".list-menu .terms-of-use").click(function() {
       	$(".list-menu a").removeClass("active");
      	$(this).addClass("active");
    	$(".SubPage").fadeOut();
       	$(".SubPage-title").fadeOut();
    	$("div.terms-of-use").delay(500).fadeIn();
    });
    
     $(".list-menu .policy").click(function() {
       	$(".list-menu a").removeClass("active");
      	$(this).addClass("active");
    	$(".SubPage").fadeOut();
       	$(".SubPage-title").fadeOut();
    	$("div.policy").delay(500).fadeIn();
    });  
  
  $(".list-menu .shipping").click(function() {
       	$(".list-menu a").removeClass("active");
      	$(this).addClass("active");
    	$(".SubPage").fadeOut();
    	$(".SubPage-title").fadeOut();
    	$("div.shipping").delay(500).fadeIn();
    });  
  
  $(".list-menu .subscribe-save").click(function() {
       	$(".list-menu a").removeClass("active");
      	$(this).addClass("active");
    	$(".SubPage").fadeOut();
    	$(".SubPage-title").fadeOut();
    	$("div.subscribe-save").delay(500).fadeIn();
    });  
  
  
  
 $('.filters-3 .clickme, .filters-3 ul li a').click(function(){
    $(".filters-3 ul").slideToggle()
    $("#filter-1 ul").slideUp()
    $("#filter-2 ul").slideUp()
    $("#filter-1 .label_title").removeClass('on');
   	$("#filter-2 .label_title").removeClass('on');
 });
  
   $('#filter-1 .label_title, #filter-1 ul li a').click(function(){
    $("#filter-1 ul").slideToggle();
    $(".filters-3 ul").slideUp()
    $("#filter-2 ul").slideUp()
    $(".filters-3 .clickme").removeClass('on');
   	$("#filter-2 .label_title").removeClass('on'); 
   });
  
   $('#filter-2 .label_title, #filter-2 ul li a').click(function(){
    $("#filter-2 ul").slideToggle();
    $("#filter-1 ul").slideUp()
    $(".filters-3 ul").slideUp()
    $("#filter-1 .label_title").removeClass('on');
   	$(".filters-3 .clickme").removeClass('on'); 
   });
  
   $('.label_title, .clickme').click(function(){
    $(this).toggleClass('on');
   });
  
  $('#filter-1 ul li a').click(function(){
    $("#filter-1 .label_title").toggleClass('on');
   })
  
 $('#filter-2 ul li a').click(function(){
    $("#filter-2 .label_title").toggleClass('on');
   })
 
 $('#filter-3 ul li a').click(function(){
    $("#filter-3 .label_title").toggleClass('on');
   })
  
  
$("#view_ingrdient").click(function(){
        $(".ingrdient-popup").fadeIn();
		$(".blk_tras_2").fadeIn();
    });
	
	$("#close_size").click(function(){
        $(".ingrdient-popup").fadeOut();
		$(".blk_tras_2").fadeOut();
    });  

/*var distance = $('#AccessibleNav').offset().top,
    $window = $(window);

$window.scroll(function() {
    if ( $window.scrollTop() >= distance ) {
        $("#shopify-section-header").addClass("sticky");
      	$(".drawer-page-content").addClass("drawer-fix");
    } else {
        $("#shopify-section-header").removeClass("sticky");  
      	$(".drawer-page-content").removeClass("drawer-fix");
    }
}); */ 
  
  
  
});


$(window).on('load resize', function () {

var wheight = $(window).height();
$("#added-box ul").css("height", wheight - 180 );

});



$(window).ready(function() {
//var wwidth = $(window).width();
  
  $(document).scroll(function() {
  var y = $(this).scrollTop();
  if (y > 49) {
    $( "#shopify-section-header" ).addClass( "sticky" );
    //$('#navigation-wrapper.sticky_header').css("background-color", "rgba(255,255,255,0.9)");
    
  } else {
    $( "#shopify-section-header" ).removeClass( "sticky" );
    //$('#navigation-wrapper.sticky_header').css("background-color", "#fff");
  }
});
  });


var $animation_elements = $('.fadeInUp');
var $window = $(window);

function check_if_in_view() {
  var window_height = $window.height();
  var window_top_position = $window.scrollTop();
  var window_bottom_position = (window_top_position + window_height);

  $.each($animation_elements, function() {
    var $element = $(this);
    var element_height = $element.outerHeight();
    var element_top_position = $element.offset().top;
    var element_bottom_position = (element_top_position + element_height);

    //check to see if this current container is within viewport
    if ((element_bottom_position >= window_top_position) &&
        (element_top_position <= window_bottom_position)) {
      $element.addClass('in-view');
    } else {
      $element.removeClass('in-view');
    }
  });
}







(function($) {

  /**
   * Copyright 2012, Digital Fusion
   * Licensed under the MIT license.
   * http://teamdf.com/jquery-plugins/license/
   *
   * @author Sam Sehnert
   * @desc A small plugin that checks whether elements are within
   *     the user visible viewport of a web browser.
   *     only accounts for vertical position, not horizontal.
   */

  $.fn.visible = function(partial) {
    
      var $t            = $(this),
          $w            = $(window),
          viewTop       = $w.scrollTop(),
          viewBottom    = viewTop + $w.height(),
          _top          = $t.offset().top,
          _bottom       = _top + $t.height(),
          compareTop    = partial === true ? _bottom : _top,
          compareBottom = partial === true ? _top : _bottom;
    
    return ((compareBottom <= viewBottom) && (compareTop >= viewTop));

  };
    
})(jQuery);


$(window).load(function() {
  //alert('1');
  $(".firstItem").each(function() {
      var el = $(this);    
      el.addClass("is-inview");   
  });
  
  
});

$(window).scroll(function(event) {
  
  $(".animate_up").each(function(i, el) {
    var el = $(el);
    if (el.visible(true)) {
      el.addClass("is-inview"); 
    } else {
      //el.removeClass("fadeIn");
    }
  });
  
});